import compose from 'ramda/src/compose'
import objOf from 'ramda/src/objOf'
import ifElse from 'ramda/src/ifElse'
import is from 'ramda/src/is'
import call from 'ramda/src/call'
import identity from 'ramda/src/identity'
import path from 'ramda/src/path'
import converge from 'ramda/src/converge'
import always from 'ramda/src/always'
import prop from 'ramda/src/prop'
import merge from 'ramda/src/merge'
import omit from 'ramda/src/omit'

const callMapLocationFunctions = key =>
  ifElse(
    prop('mapLocation'),
    compose(
      objOf(key),
      ifElse(is(Function), fn => call(fn), identity),
      path(['mapLocation', key])
    ),
    always(undefined)
  )

const mergeLatAndLng = (o, lat, lng) => merge(o, { location: lat ? merge(lat, lng) : null })

export default
  compose(
    omit('mapLocation'),
    converge(
      mergeLatAndLng, [
        identity,
        callMapLocationFunctions('lat'),
        callMapLocationFunctions('lng')
      ]
    )
  )



// WEBPACK FOOTER //
// ./src/helpers/projects/extractMapDependencies.js